import { gate } from 'hub-http/gates';
export const gates = {
  CONVERSATIONAL_ENRICHMENT_BETA: gate('ConversationalEnrichment:EmailParser:Beta'),
  CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE: gate('ConversationalEnrichment:Model:EmploymentChange'),
  CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE_TOGGLE: gate('ConversationalEnrichment:FEToggle:EmploymentChange'),
  CONVERSATIONAL_ENRICHMENT_OUT_OF_OFFICE_TOGGLE: gate('ConversationalEnrichment:FEToggle:OutOfOffice'),
  ENRICHMENT_INCLUDED: gate('DataEnrichment:Included'),
  HUBSPOT_CREDITS: gate('HubSpotCredits'),
  SMART_FILL_BATCH: gate('DataEnrichment:SmartFillBatch'),
  SMART_FILL_LIST: gate('DataEnrichment:SmartFillList'),
  SMART_FILL_ON_SETUP: gate('CRM:PropMgmt:SmartFillOnSetup'),
  TEST_GATE: 'TestGate'
};